import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PaybackStrip } from '@wit-support/ui-domain';
import { cn } from '@wit-support/ui';
import { afterFees, num2, pct } from '../format.js';
import { GLOSSARY } from '../glossary.js';
import { reasonText, verdictTone } from '../verdict.js';
/** Подпись полосы: «Скорее всего от X до Y · шанс окупиться N %». */
export function stripLabel(g, reason) {
    const a = g.answer;
    const lo = a.interval?.lo ?? null;
    const hi = a.interval?.hi ?? null;
    if (a.roas3 === null)
        return reasonText(reason ?? 'мало');
    const range = lo !== null && hi !== null
        ? `Скорее всего от ${num2(lo)} до ${num2(hi)}`
        : `Около ${num2(a.roas3)}`;
    return a.p !== null ? `${range} · шанс окупиться ${pct(a.p)}` : range;
}
/**
 * Подсказка полосы (Tooltip кита): вывод в цифрах и как читать шкалу —
 * точка, полоса, пунктир порога и, если есть, кольцо прошлого периода.
 */
export function stripHint(label, theta, prev) {
    return (_jsxs("span", { className: "flex flex-col gap-1", children: [_jsx("b", { className: "font-semibold", children: label }), _jsxs("span", { children: ["\u0422\u043E\u0447\u043A\u0430 \u2014 ", GLOSSARY.dot.hint(theta).toLowerCase()] }), _jsxs("span", { children: ["\u041F\u043E\u043B\u043E\u0441\u0430 \u2014 ", GLOSSARY.band.hint(theta).replace(/^С/, 'с')] }), _jsxs("span", { children: ["\u041F\u0443\u043D\u043A\u0442\u0438\u0440 \u2014 \u043F\u043E\u0440\u043E\u0433 \u043E\u043A\u0443\u043F\u0430\u0435\u043C\u043E\u0441\u0442\u0438, ", num2(theta), " $ \u043D\u0430 \u043A\u0430\u0436\u0434\u044B\u0439 1 $ (\u0442\u0430\u043A\u043E\u0439 \u0437\u0430\u043F\u0430\u0441 \u0437\u0430\u043B\u043E\u0436\u0435\u043D \u0432 \u0440\u0430\u0441\u0447\u0451\u0442)."] }), prev ? (_jsxs("span", { children: ["\u041A\u043E\u043B\u044C\u0446\u043E \u2014 ", prev.label, ": ", num2(prev.roas), "."] })) : null] }));
}
/** Правый край общей шкалы: max(base, max hi). */
export function stripMax(groups, base = 2.2) {
    let m = base;
    for (const g of groups) {
        const hi = g.answer.interval?.hi ?? null;
        const r = g.answer.roas3;
        if (hi !== null && hi > m)
            m = hi;
        if (r !== null && r > m)
            m = r;
    }
    return m;
}
/**
 * Ячейка «Вернётся на 1 $»: полоса и число. Без оценки — «—» с причиной.
 */
export function StripCell({ group, theta, max, className, }) {
    const a = group.answer;
    const af = afterFees(group.horizons['120']);
    const reason = af.available ? null : af.reason;
    const label = stripLabel(group, reason);
    return (_jsxs("div", { className: cn('flex min-w-[140px] items-center gap-2', className), children: [_jsx(PaybackStrip, { value: a.roas3, lo: a.interval?.lo ?? null, hi: a.interval?.hi ?? null, threshold: theta, max: max, tone: verdictTone(a.verdict), ariaLabel: label, hint: stripHint(label, theta), className: "flex-1" }), _jsx("b", { className: cn('min-w-[34px] text-right tabular-nums', a.verdict === null && 'font-normal text-[var(--color-text-muted)]'), children: a.roas3 === null ? '—' : num2(a.roas3) })] }));
}
//# sourceMappingURL=strip-cell.js.map